import React, { Fragment } from "react";
import { InCallIcon } from "../../assets/icons";
import { OutCallIcon } from "../../assets/icons";
import {
  StyledSectionWrapper,
  StyledContentWrapper,
  StyledDescription
} from "./ui";

const PrivateHosting = () => {
  return (
    <Fragment>
      <StyledSectionWrapper>
        <p>Playing sports and activities never easier</p>
        <h3>Automate - Regulate - Motivate</h3>

        <StyledContentWrapper>
          <div className="item-wrapper">
            <div className="image-wrapper">
              <img src="./images/private-hosting-1.png" alt="" />
            </div>
            <StyledDescription
              padding={["0 0 0 16px", "0 20px 0 0", null, "0 57px 0 0"]}
              alignItems={["flex-start", "flex-end"]}
              textAlign={["left", "right"]}
            >
              <span>
                <OutCallIcon />
              </span>
              <h4>Outcall</h4>
              <p>
                Add cities and radius's, customise your prices based on where
                you teach
              </p>
            </StyledDescription>
          </div>

          <div className="item-wrapper">
            <div className="image-wrapper">
              <img src="./images/private-hosting-2.png" alt="" />
            </div>
            <StyledDescription
              padding={["0 10px 0 0", "0 0 0 20px ", null, "0 0 0 57px "]}
              alignItems={["flex-start", null]}
              textAlign={["left", null]}
            >
              <span>
                <InCallIcon />
              </span>
              <h4>Incall</h4>
              <p>Set specific venues that you teach specific sports</p>
            </StyledDescription>
          </div>
        </StyledContentWrapper>
      </StyledSectionWrapper>
    </Fragment>
  );
};

export default PrivateHosting;
